import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { route } from '../config';
import { DokumentePrecache } from './dokumente-precache';

const DocumentView = lazy(() => import('./DocumentView'));
const FolderView = lazy(() => import('./FolderView'));

export default function Dokumente() {
  return (
    <>
      <DokumentePrecache />
      <Route path={route}>
        <Route exact path={route} component={FolderView} />
        <Route path={`${route}/f/:id`} component={FolderView} />
        <Route path={`${route}/d/:id`} component={DocumentView} />
      </Route>
    </>
  );
}
